import colors from 'vuetify/es5/util/colors'

export const healthColors = [
  'green darken-1',
  'yellow darken-1',
  'red darken-2' ]
export const healthColorsText = [
  'green--text text--darken-1',
  'yellow--text text--darken-1',
  'red--text text--darken-2' ]
export const healthColorsHex = [ colors.green.darken1, colors.yellow.darken1, colors.red.darken2 ]
